import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { PreferenceFrequency } from '../../../models/preference-frequency/preference-frequency.model';
import { PreferenceFrequencySerializer } from '../../../models/preference-frequency/preference-frequency-serializer.class';

@Injectable()
export class PreferenceFrequenciesService extends BaseApiService<PreferenceFrequency> {
    constructor(httpClient: HttpClient) {
        super(
            httpClient, 
            null, 
            "preferenceFrequencys", 
            new PreferenceFrequencySerializer(), 
            new CustomErrorHandlerService()
        );
    }
}